$(() => {
  $('[data-exec-copy]').on('click', function () {
    if (!confirm('転写しますか?入力内容は上書きされます。')) {
      return;
    }
    const copy = (src, dst) => $(dst).val($(src).val());
    $('[data-copy-to]').each(function () {
      copy(this, $(this).data('copy-to'));
    });
  });
});
